import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

// Redirects to "/" unless the CLEAR sign-in toggle is enabled.
export const clearSigninGuard = WrappedComponent => {
  function ClearSigninGuard(props) {
    const { useToggleValue, useToggleLoadingValue, TOGGLE_NAMES } =
      useFeatureToggle();
    const isLoading = useToggleLoadingValue();
    const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);
    const { router } = props;

    useEffect(() => {
      if (!isLoading && !clearSigninEnabled) {
        router.replace('/');
      }
    }, [isLoading, clearSigninEnabled, router]);

    if (isLoading) {
      return (
        <section className="container row login vads-u-padding--3">
          <va-loading-indicator
            message="Loading your sign-in page..."
            set-focus
          />
        </section>
      );
    }

    if (!clearSigninEnabled) {
      return null;
    }

    return <WrappedComponent {...props} />;
  }

  ClearSigninGuard.propTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,
  };

  return ClearSigninGuard;
};
